import { FC, useRef } from 'react';
import './style.scss';
import { Row, Col } from 'antd';
import moment from 'moment';
import { NET, OTHER } from '../enum';

const List: FC<{
    data: Record<string, any>;
    imgData?: any[];
    options: Record<string, any>[];
}> = ({ data = {}, imgData = [], options = [] }) => {
    const toPdfRef = useRef<HTMLDivElement>(null);

    function findName(val: string): string {
        const [item] = options?.filter(({ dictBn }) => dictBn === val);
        return item?.name || '';
    }

    function getMediaOptions() {
        const data = options.filter(({ type }) => type === 'media');
        return data.map(({ name, dictBn }) => ({
            label: name,
            value: dictBn
        }));
    }

    const media = data?.media || [];

    return (
        <div className='pdf-box' ref={toPdfRef}>
            <div style={{ textAlign: 'right', paddingRight: 15 }}>申请受理号 _______________</div>
            <h1>四川省中医医疗广告成品样件表</h1>
            <div style={{ textAlign: 'right', paddingRight: 15, paddingBottom: 15 }}>
                提交日期：{moment(new Date()).format('YYYY年MM月DD日')}
            </div>
            <div className='pdf-body'>
                <Row className='ant-row-c'>
                    <Col span={2} className='ant-col-c'>
                        医<br />
                        疗<br />
                        机<br />
                        构<br />
                        情<br />况
                    </Col>
                    <Col span={22}>
                        <Row className='ant-row-c'>
                            <Col span={4} className='ant-col-c pdf-item-lable'>
                                第一名称
                            </Col>
                            <Col span={20} className='ant-col-c'>
                                {data.orgName || ''}
                            </Col>
                        </Row>
                        <Row className='ant-row-c'>
                            <Col span={4} className='ant-col-c pdf-item-lable'>
                                地址
                            </Col>
                            <Col span={20} className='ant-col-c'>
                                {data.address || ''}
                            </Col>
                        </Row>
                        <Row className='ant-row-c'>
                            <Col span={4} className='pdf-item-lable ant-col-c'>
                                机构类别
                            </Col>
                            <Col span={8} className='ant-col-c'>
                                {findName(data.category) || ''}
                            </Col>
                            <Col span={4} className='ant-col-c'>
                                执业许可证
                                <br />
                                登记号
                            </Col>
                            <Col className='ant-col-c' span={8}>
                                {data.registerBn || ''}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={4} className='ant-col-c'>
                                法定代表人
                                <br />
                                （主要负责人）
                            </Col>
                            <Col span={8} className='ant-col-c'>
                                {data.legalPerson || ''}
                                <br />
                                {data.principal ? `(${data.principal})` : ''}
                            </Col>
                            <Col span={4} className='pdf-item-lable ant-col-c'>
                                联系电话
                            </Col>
                            <Col className='ant-col-c' span={8}>
                                {data.phone || ''}
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className='ant-row-c'>
                    <Col span={6} className='pdf-item-lable ant-col-c'>
                        拟发布媒体类别
                    </Col>
                    <Col
                        span={18}
                        className='ant-col-c'
                        style={{ flexWrap: 'inherit', justifyContent: 'start' }}
                    >
                        {getMediaOptions().map(({ label, value }, index) => (
                            <span
                                key={index}
                                className={[
                                    'check-box',
                                    data?.media && data?.media?.includes(value) ? 'selected' : null
                                ].join(' ')}
                                style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
                            >
                                {value === NET && media.includes(value) && !!data.publish
                                    ? `${label}`//(${data.publish})
                                    : value === OTHER && media.includes(value) && !!data.other
                                    ? `${label}(${data.other})`
                                    : label}
                            </span>
                        ))}
                    </Col>
                </Row>
                <Row className='ant-row-c'>
                    <div style={{ flex: 1, padding: '5px 15px' }}>广告成品样件粘贴处：</div>
                    <Col
                        span={24}
                        className='ant-col-c'
                        style={{
                            border: 'none',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            paddingBottom: 0,
                            paddingTop: 5
                        }}
                        id='yj-img-box'
                    >
                        {imgData.length ? null : (
                            <div
                                style={{
                                    width: 400,
                                    height: 300,
                                    border: '1px dashed #999'
                                }}
                            ></div>
                        )}
                        {imgData.map((item: Record<string, any>, index: number) => (
                            <div
                                key={index}
                                className='img_item'
                                style={{
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                    height: '660px',
                                    overflow: 'hidden'
                                }}
                            >
                                <img
                                    src={item.url}
                                    style={{
                                        maxWidth: 858,
                                        maxHeight: 620
                                    }}
                                    draggable='false'
                                    alt=''
                                />
                                <div style={{ textAlign: 'center', marginBottom: 15 }}>
                                    图 ({index + 1}) {item?.type ? item?.type.join('、') : ''}
                                </div>
                            </div>
                        ))}
                    </Col>
                    <div style={{ flex: 1, padding: '15px', textAlign: 'center' }}>
                        <span style={{ marginRight: '40%' }}>(医疗机构盖章)</span>
                        <span>(审查机关盖章)</span>
                    </div>
                    <div style={{ padding: 10, textIndent: '28px' }}>
                        中医医疗广告发布法律责任：
                        按照《中华人民共和国中医药法》第五十七条规定“违反本法规定发布的中医医疗广告内容与经审查批准的内容不相符的，由原审查部门撤销该广告的审查批准文件，一年内不受理该医疗机构的广告审查申请。违反本法规定，发布中医医疗广告有前款规定以外违法行为的，依照《中华人民共和国广告法》的规定给予处罚。
                    </div>
                </Row>
            </div>
            <div className='page-box' id='footer'></div>
        </div>
    );
};

export default List;
